import { FC } from 'react';
import { Calendar } from 'lucide-react';
import type { TherapistAppointment } from './types';
import { formatDate } from './dateUtils';
import { AppointmentCard } from './AppointmentCard';

interface DayViewProps {
  date: Date;
  appointments: TherapistAppointment[];
}

export const DayView: FC<DayViewProps> = ({ date, appointments }) => {
  const dayAppointments = appointments
    .filter((apt) => apt.date === formatDate(date))
    .sort((a, b) => a.startTime.localeCompare(b.startTime));

  if (dayAppointments.length === 0) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-lg p-12 text-center border-2 border-dashed border-gray-300 dark:border-slate-600">
        <Calendar className="w-16 h-16 text-gray-400 dark:text-slate-500 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-gray-900 dark:text-slate-100 mb-2">
          No Appointments
        </h3>
        <p className="text-gray-600 dark:text-slate-400">
          You have no appointments scheduled for this day.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {dayAppointments.map((appointment) => (
        <AppointmentCard key={appointment.id} appointment={appointment} />
      ))}
    </div>
  );
};
